<body>
  <div class="grid-overlay">
    <app-page-header>
      <button class="header-action-btn" (click)="goBack()">{{ 'common.back' | translate }}</button>
    </app-page-header>
    <div class="setting-data">
      <div class="second-headboard">
        <h1>{{ 'updatePortal.title' | translate }}</h1>
        <!-- <img src="../../assets/icons/1234.png" alt="logo de Billcentrix"> -->
        <div class="linked-icons" >
          <button class="active" >{{ 'updatePortal.buttons.update' | translate }}</button>
          <button   (click)="goToPlans()">{{ 'updatePortal.buttons.editPlans' | translate }}</button>
          @if (!showPaymentButton) {
            <button>{{ 'updatePortal.buttons.activeSubscription' | translate }}</button>
          }
          @if (showPaymentButton) {
            <button>{{ 'updatePortal.buttons.activateSubscription' | translate }}</button>
          }
          <!-- <img src="../../assets/icons/1_cuenta_on.png" alt="Paso 1: Cuenta">
          <img src="../../assets/icons/2_portales_off.png" alt="Paso 2: Portal" (click)="goToTemplates()">
          <img src="../../assets/icons/3_personalizar_off.png" alt="Paso 3: Personalizar" (click)="goToFeatures()">
          <img src="../../assets/icons/4_planes_off.png" alt="Paso 4: Planes" (click)="goToPlans()"> -->
        </div>
      </div>
      <div class="general-data">
        <h1>{{ 'updatePortal.generalData.title' | translate }}</h1>
        <form [formGroup]="partnerForm" >
          <div class="grid">
            <div class="left">
              <div class="items">
                <label for="name">{{ 'updatePortal.generalData.companyName' | translate }}</label>
                <input [readOnly]="isNewService" [formControl]="partnerForm.controls['name_partner']"
                  type="text" [placeholder]="'updatePortal.generalData.companyNamePlaceholder' | translate">
                  @if (partnerForm.controls['name_partner'].hasError('required') &&
                    partnerForm.controls['name_partner'].touched) {
                    <small
                    class="form-error-msg"> {{ 'updatePortal.generalData.companyNameError' | translate }} </small>
                  }
                </div>
                <div class="items">
                  <label for="country">{{ 'updatePortal.generalData.country' | translate }}</label>
                  <div class="select-wrapper">
                    <select id="country" [formControl]="partnerForm.controls['country']" (change)="cityByCountry($event.target.value)">
                      <option [disabled]="isNewService" disabled="" selected="" value="">{{ 'updatePortal.generalData.selectOption' | translate }}</option>
                      @for (country of countries; track country) {
                        <option [disabled]="isNewService"  [value]="country.id" >{{ country.name_country }}</option>
                      }
                    </select>
                    <i class="arrow"></i>
                  </div>
                </div>

                <div class="items">
                  <label for="country">{{ 'updatePortal.generalData.currency' | translate }}</label>
                  <div class="select-wrapper">
                    <select id="currency" [formControl]="partnerForm.controls['currency_id']" >
                      <option  selected="" value="">{{ 'updatePortal.generalData.selectOption' | translate }}</option>
                      @for (currency of currencies; track currency) {
                        <option  [value]="currency.id" >  {{ currency.codeCurrency }} - {{ currency.nameCurrency }}</option>
                      }
                    </select>
                    <i class="arrow"></i>
                  </div>
                </div>
                <div class="items">
                  <label for="phone">{{ 'updatePortal.generalData.phone' | translate }}</label>
                  <input [readOnly]="isNewService" (keypress)="onlyNumberKey($event)" [formControl]="partnerForm.controls['phone_partner']" type="text" [placeholder]="'updatePortal.generalData.phonePlaceholder' | translate">
                  @if (partnerForm.controls['phone_partner'].hasError('required') && partnerForm.controls['phone_partner'].touched) {
                    <small
                      class="form-error-msg"> {{ 'updatePortal.generalData.phoneError' | translate }}
                    </small>
                  }
                </div>

                <div class="items space">
                  <label for="country">{{ 'updatePortal.generalData.emailNotifications' | translate }}</label>
                  <button class="info-button" (mouseenter)="showHelpText=true" (mouseleave)="showHelpText=false">
                    ?


                    @if (showHelpText) {
                      <span class="tooltip-text" >
                        <h2>{{ 'updatePortal.generalData.emailNotifications' | translate }}</h2>{{ 'updatePortal.generalData.emailNotificationsTooltip' | translate }}</span>
                      }
                    </button>
                    <div class="select-wrapper">
                      <select [formControl]="partnerForm.controls['create_email_notification']">
                        <option   value="false">{{ 'updatePortal.generalData.no' | translate }}</option>
                        <option   value="true" >{{ 'updatePortal.generalData.yes' | translate }}</option>
                      </select>
                      <i class="arrow islarge"></i>
                      @if (partnerForm.controls['create_email_notification'].hasError('required') && partnerForm.controls['create_email_notification'].touched) {
                        <small
                          class="form-error-msg"> {{ 'updatePortal.generalData.emailNotificationsError' | translate }}
                        </small>
                      }
                    </div>

                  </div>

                </div>
                <div class="right">
                  <div class="items">
                    <label for="address">{{ 'updatePortal.generalData.address' | translate }}</label>
                    <input [readOnly]="isNewService" [formControl]="partnerForm.controls['adress_partner']"  type="text" [placeholder]="'updatePortal.generalData.addressPlaceholder' | translate">
                    @if (partnerForm.controls['adress_partner'].hasError('required') && partnerForm.controls['adress_partner'].touched) {
                      <small
                      class="form-error-msg"> {{ 'updatePortal.generalData.addressError' | translate }} </small>
                    }
                  </div>
                  <div class="items">
                    <label for="country">{{ 'updatePortal.generalData.city' | translate }}</label>
                    <div class="select-wrapper">
                      <select [formControl]="partnerForm.controls['city']">
                        <option [disabled]="isNewService"  selected="" value="">{{ 'updatePortal.generalData.selectOption' | translate }}</option>
                        @for (city of cities; track city) {
                          <option [disabled]="isNewService"  [value]="city.id" >{{ city.name_city }}</option>
                        }
                      </select>
                      <i class="arrow"></i>
                      @if (partnerForm.controls['city'].hasError('required') && partnerForm.controls['city'].touched) {
                        <small
                          class="form-error-msg"> {{ 'updatePortal.generalData.cityError' | translate }}
                        </small>
                      }
                    </div>
                  </div>
                  <div class="items">
                    <div class="elements-separed">
                      <label for="phone">{{ 'updatePortal.generalData.serviceName' | translate }}</label><button class="info-button" (mouseenter)="showHelpText=true" (mouseleave)="showHelpText=false">
                      ?
                      <span class="tooltip-text"  >
                        <h2>{{ 'updatePortal.generalData.serviceName' | translate }}</h2>{{ 'updatePortal.generalData.serviceNameTooltip' | translate }}</span>
                      </button>
                      <!-- <a href="#">Habilitar dominio personalizado</a> -->
                    </div>
                    <input (keypress)="omit_special_char($event)" [readOnly]="exist"  [formControl]="partnerForm.controls['name_portal']" type="text" [placeholder]="'updatePortal.generalData.serviceNamePlaceholder' | translate">

                    @if (partnerForm.controls['name_portal'].hasError('required') && partnerForm.controls['name_portal'].touched) {
                      <small
                      class="form-error-msg"> {{ 'updatePortal.generalData.serviceNameError' | translate }} </small>
                    }
                  </div>


                  <div class="items space">
                    <label for="country">{{ 'updatePortal.generalData.allowDebt' | translate }}</label> <button class="info-button" (mouseenter)="showHelpText=true" (mouseleave)="showHelpText=false">
                    ?


                    @if (showHelpText) {
                      <span class="tooltip-text" >
                        <h2>{{ 'updatePortal.generalData.allowDebt' | translate }}</h2>{{ 'updatePortal.generalData.allowDebtTooltip' | translate }}</span>
                      }
                    </button>

                    <div class="select-wrapper">
                      <select [formControl]="partnerForm.controls['acummulate_debt']">
                        <option value="false">{{ 'updatePortal.generalData.no' | translate }}</option>
                        <option value="true">{{ 'updatePortal.generalData.yes' | translate }}</option>
                      </select>
                      <i class="arrow islarge"></i>
                      @if (partnerForm.controls['acummulate_debt'].hasError('required') && partnerForm.controls['acummulate_debt'].touched) {
                        <small class="form-error-msg">{{ 'updatePortal.generalData.allowDebtError' | translate }}</small>
                      }
                    </div>


                  </div>

                </div>
              </div>
            </form>
          </div>

          <div class="processing-account">
            <h1>{{ 'updatePortal.processingAccount.title' | translate }}</h1>
            <form [formGroup]="partnerForm" >
              <div class="grid">
                <div class="left">
                  <div class="items">
                    <label for="country">{{ 'updatePortal.processingAccount.select' | translate }}</label>
                    <div class="select-wrapper">
                      <select id="bank" [formControl]="partnerForm.controls['bank']">
                        <option disabled="" selected="" value="">{{ 'updatePortal.processingAccount.selectOption' | translate }}</option>
                        @for (bank of banks; track bank) {
                          <option  [value]="bank.id" > {{ bank.name }}</option>
                        }
                      </select>
                      <i class="arrow"></i>
                      @if (partnerForm.controls['bank'].hasError('required') && partnerForm.controls['bank'].touched) {
                        <small
                          class="form-error-msg"> {{ 'updatePortal.processingAccount.bankError' | translate }}
                        </small>
                      }
                    </div>
                  </div>
                </div>
                <div class="right">
                  <div class="items">
                    <p>{{ 'updatePortal.processingAccount.description' | translate }}</p>
                    <div class="flex-style">
                      <label style="color: #5197FF; text-decoration: underline;" (click)="sendContactMail(1)">{{ 'updatePortal.processingAccount.openAccount' | translate }}</label>
                      <!-- <button class="custom-account-btn">Cuenta personalizada</button> -->
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="notifications">
            <h1>{{ 'updatePortal.notifications.title' | translate }}</h1>
            <form [formGroup]="partnerForm" >
              <div class="grid">
                <div class="left">
                  <div class="items">
                    <div class="elements-separed">
                      <label for="phone">{{ 'updatePortal.notifications.whatsapp' | translate }}</label>
                    </div>
                    <div class="flex-style">
                      <label style="color: #5197FF; text-decoration: underline;" for="" (click)="sendContactMail(2)">{{ 'updatePortal.notifications.whatsappContact' | translate }}</label>
                    </div>
                    <div class="select-wrapper">
                      <select id="whatsappNumber" [formControl]="partnerForm.controls['whatsappNumber']" >
                        <option disabled="" selected="" value="">{{ 'updatePortal.notifications.selectOption' | translate }}</option>
                        @for (number of numbers; track number) {
                          <option  [value]="number.id"  >  {{ number.number }} </option>
                        }
                      </select>
                      <i class="arrow"></i>
                      @if (partnerForm.controls['whatsappNumber'].hasError('required') && partnerForm.controls['whatsappNumber'].touched) {
                        <small
                          class="form-error-msg"> {{ 'updatePortal.notifications.whatsappError' | translate }}
                        </small>
                      }
                    </div>
                  </div>
                  <p>{{ 'updatePortal.notifications.whatsappDescription' | translate }}</p>
                </div>
                <div class="right">
                  <div class="items">
                    <div class="elements-separed">
                      <label for="phone">{{ 'updatePortal.notifications.email' | translate }}</label>
                    </div>
                    <div class="flex-style">
                      <label style="color: #5197FF; text-decoration: underline;" for="" (click)="sendContactMail(3)">{{ 'updatePortal.notifications.emailContact' | translate }}</label>
                    </div>
                    <input [formControl]="partnerForm.controls['email_partner']" readonly type="text" placeholder="noreply@billcentrix.com">
                    @if (partnerForm.controls['email_partner'].hasError('required') && partnerForm.controls['email_partner'].touched) {
                      <small
                      class="form-error-msg"> {{ 'updatePortal.notifications.emailError' | translate }} </small>
                    }
                  </div>
                  <p>{{ 'updatePortal.notifications.emailDescription' | translate }}</p>

                  @if (partnerForm.controls['email_partner'].hasError('email') && partnerForm.controls['email_partner'].touched) {
                    <small
                    class="form-error-msg"> {{ 'updatePortal.notifications.emailInvalidError' | translate }} </small>
                  }
                </div>
              </div>
            </form>
          </div>
        </div>
        <div class="options-buttons">
          <button class="back-btn" (click)="goBack()" >{{ 'updatePortal.mySubscriptions' | translate }}</button>
          <button class="back-btn" (click)="goToPlans()" >{{ 'updatePortal.editPlans' | translate }}</button>
          <!-- <button *ngIf="showPaymentButton" class="continue-btn" (click)="processPayment()" >Finalizar portal</button>   -->
          <!-- [disabled]="!showPaymentButton" -->
          <button class="continue-btn" (click)="update()" >{{ 'updatePortal.save' | translate }}</button>
        </div>
      </div>
    </body>
